import { render } from "./ThemDeTai.vue?vue&type=template&id=4f7c351a&scoped=true&ts=true"
import script from "./ThemDeTai.vue?vue&type=script&lang=ts"
export * from "./ThemDeTai.vue?vue&type=script&lang=ts"

import "./ThemDeTai.vue?vue&type=style&index=0&id=4f7c351a&lang=scss&scoped=true"

import exportComponent from "/Volumes/DATA/Project/WebsiteProject/NghienCuuKhoaHoc/NCKH_FontEnd/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f7c351a"]])

export default __exports__